export default "__VITE_ASSET__891793d9__"